import { Link } from "react-router-dom";
import { ArrowRight, DoorOpen } from "lucide-react";

const EXAMPLES = [
  { biz: "Restaurant", give: "Free appetizer", monetize: ["Entrées", "Drinks", "Dessert", "Repeat visit"], img: "https://images.unsplash.com/photo-1623653387945-2fd25214f8fc?w=800" },
  { biz: "Coffee Shop", give: "Free coffee", monetize: ["Breakfast", "Pastry", "Add-ons", "Repeat visits"], img: "https://images.unsplash.com/photo-1502462041640-b3d7e50d0662?w=800" },
  { biz: "Salon", give: "Free conditioning treatment", monetize: ["Hair service", "Retail products", "Future appointments"], img: "https://images.unsplash.com/photo-1600948836101-f9ffda59d250?w=800" },
  { biz: "Gym", give: "Free class", monetize: ["Membership", "Personal training", "Supplements"], img: "https://images.pexels.com/photos/6339401/pexels-photo-6339401.jpeg?auto=compress&cs=tinysrgb&w=800" },
];

export default function LocalBusinesses() {
  return (
    <div>
      <section className="relative overflow-hidden grain" style={{ background: "linear-gradient(160deg,#E4FBF1 0%,#FAFAF9 100%)" }}>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-20 text-center">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white friib-shadow text-xs font-bold text-stone-600 mb-5">Friib Local · For Businesses</span>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-stone-900 leading-[1.05]">Give them a reason to<br />walk through the door.</h1>
          <p className="mt-5 text-lg text-stone-600 max-w-xl mx-auto">Turn something inexpensive for you into a powerful reason for a new customer to visit your business.</p>
          <div className="mt-8 flex flex-wrap gap-3 justify-center">
            <Link to="/register" className="inline-flex items-center gap-2 px-8 py-4 rounded-full font-bold text-white text-lg transition-transform hover:scale-105" style={{ background: "var(--mint)" }}>Create Your First Friib <ArrowRight size={18} /></Link>
            <Link to="/local" className="inline-flex items-center gap-2 px-8 py-4 rounded-full font-bold text-stone-900 bg-white friib-shadow text-lg">See How It Works</Link>
          </div>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 py-16">
        <div className="rounded-3xl bg-white border border-stone-100 friib-shadow p-8 lg:p-12 text-center">
          <DoorOpen size={40} style={{ color: "var(--mint)" }} className="mx-auto mb-4" />
          <p className="text-xl text-stone-700 font-medium leading-relaxed">Your appetizer costs you <b>$3</b> to make. Its menu value is <b>$12</b>. Give it away. Bring in a customer. Sell the entrée, drinks and dessert.</p>
          <p className="mt-5 font-display text-2xl font-extrabold text-stone-900">Don't discount everything. Give away one strategic thing.</p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        <h2 className="font-display text-3xl font-bold text-stone-900 text-center mb-10">See it in action</h2>
        <div className="grid sm:grid-cols-2 gap-6">
          {EXAMPLES.map((e) => (
            <div key={e.biz} className="rounded-3xl bg-white border border-stone-100 friib-shadow overflow-hidden">
              <img src={e.img} alt={e.biz} className="w-full h-44 object-cover" />
              <div className="p-6">
                <p className="text-xs font-bold uppercase tracking-wider text-stone-400">{e.biz}</p>
                <p className="font-display text-xl font-bold text-stone-900 mb-3">Give: {e.give}</p>
                <p className="text-sm font-semibold text-stone-500 mb-2">Monetize with:</p>
                <div className="flex flex-wrap gap-2">{e.monetize.map((m) => <span key={m} className="px-3 py-1 rounded-full text-xs font-semibold" style={{ background: "var(--mint-light)", color: "var(--mint-hover)" }}>{m}</span>)}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 py-16 text-center">
        <div className="rounded-3xl p-10 text-white relative overflow-hidden" style={{ background: "var(--ink)" }}>
          <div className="grain absolute inset-0 opacity-20" />
          <h2 className="font-display text-3xl font-extrabold mb-2 relative z-10">Facebook gets attention. Google gets searches.</h2>
          <p className="text-2xl font-display font-bold relative z-10" style={{ color: "var(--mint)" }}>Friib gets customers through your door.</p>
          <Link to="/merchant" className="relative z-10 inline-flex items-center gap-2 px-8 py-4 rounded-full font-bold text-stone-900 bg-white mt-6">Open Merchant Portal <ArrowRight size={18} /></Link>
        </div>
      </section>
    </div>
  );
}
